import React, { useEffect } from 'react'
import MobileView from '../../layouts/MobileView/MobileView'
import AuthLayout from '../../layouts/AuthLayout'
import { APP_NAME } from '../../constants/constants'
import { Link, useNavigate } from 'react-router-dom'
import { getIntendedPath } from '../../redux-stores/store'

const RegistrationSuccess: React.FC = () => {

    const navigate = useNavigate();

    useEffect(() => {
        // Redirect to intended path after 10 seconds
        const timer = setTimeout(() => {
            navigate(getIntendedPath() ?? '/');
        }, 10000);

        return () => clearTimeout(timer);
    }, [])

    return (
        <MobileView>
            <AuthLayout contentMinHeight='35%'>
                <div className="position-relative h-100">
                    <div className='d-flex flex-column align-items-center'>
                        <h4 className="pop w-100 text-center auth-heading">Welcome To {APP_NAME}</h4>
                        <span className='otp-verification-text'>Your account has been successfully created.</span>
                    </div>
                </div>
                <Link to={getIntendedPath() ?? '/'} className="new-ui-btn reg-success-continue-btn">Continue</Link>
            </AuthLayout>
        </MobileView>
    )
}

export default RegistrationSuccess
